import { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';

// Fecha de ayer según el reloj del navegador (el club trabaja en -03:00).
const ayerLocal = () => {
  const ahora = new Date();
  const offset = ahora.getTimezoneOffset() * 60000;
  const ayer = new Date(ahora.getTime() - offset - 24 * 60 * 60000);
  return ayer.toISOString().slice(0, 10);
};

export default function useCajaCierre() {
  const [fecha, setFecha] = useState(ayerLocal);
  const [dia, setDia] = useState(null);
  const [cierres, setCierres] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const cargarCierres = useCallback(async () => {
    try {
      const response = await api.get('/caja/cierres', {
        params: { limit: 30 },
      });
      setCierres(response.data || []);
    } catch (err) {
      console.error('Error al listar cierres de caja:', err);
    }
  }, []);

  const cargar = useCallback(async () => {
    if (!fecha) return;

    setCargando(true);
    setError('');

    try {
      const response = await api.get('/caja/cierre', {
        params: { fecha },
      });
      setDia(response.data);
    } catch (err) {
      setDia(null);
      setError(
        err.response?.data?.error ||
          'No se pudo calcular el cierre de caja'
      );
    } finally {
      setCargando(false);
    }
  }, [fecha]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  useEffect(() => {
    cargarCierres();
  }, [cargarCierres]);

  // Los errores se propagan para que el modal del PIN los muestre.
  const cerrarDia = async ({ conteos, observaciones, autorizacionPin }) => {
    const response = await api.post('/caja/cierres', {
      fecha,
      conteos,
      observaciones,
      autorizacionPin,
    });

    setDia(response.data);
    await cargarCierres();

    return response.data;
  };

  return {
    fecha,
    setFecha,
    dia,
    cierres,
    cargando,
    error,
    cargar,
    cerrarDia,
  };
}
